import { render } from "./Invited.vue?vue&type=template&id=56581658&scoped=true&ts=true"
import script from "./Invited.vue?vue&type=script&lang=ts"
export * from "./Invited.vue?vue&type=script&lang=ts"

import "./Invited.vue?vue&type=style&index=0&id=56581658&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56581658"]])

export default __exports__